import React from 'react';
import { DebounceInput } from 'react-debounce-input';

export default function DistanceFilter({ value, onChange }) {
    return (
        <div className="row row--equalized gutters-2">
            <div className="col-6">
                <label className="mb-1 font-weight-normal text--sm">Postcode</label>
                <DebounceInput
                    minLength={4}
                    debounceTimeout={500}
                    type="text"
                    className="form-control"
                    placeholder="1234 AB"
                    value={value?.postcode || ''}
                    onChange={(e) =>
                        onChange({ ...value, postcode: e.target.value })
                    }
                />
            </div>
            <div className="col-6">
                <label className="mb-1 font-weight-normal text--sm">Straal (km)</label>
                <select
                    className="custom-select"
                    value={value?.radius || ''}
                    onChange={(e) =>
                        onChange({ ...value, radius: e.target.value })
                    }
                >
                    <option value="">Afstand</option>
                    <option value="25">25 km</option>
                    <option value="50">50 km</option>
                    <option value="75">75 km</option>
                </select>
            </div>
        </div>
    );
}
